import { Link } from "react-router-dom";
import "./Home.css";
import therapistImg from "../../assets/M_pic.jpg";
import AccordionItem from "../../components/AccordionItem/AccordionItem";
import MapWithMarkers from "../../components/MapWithMarkers/MapWithMarker";
import Header from "../../components/Header/Header";
import React, { useEffect, useState } from "react";
import EducationCarousel from "../../components/EducationCarousel/EducationCarousel";
import PosterBanner from "../../components/PosterBanner/PosterBanner";


function Home() {
  const [small, setSmall] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSmall(true);
      } else {
        setSmall(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);






  return (
    <>

      {/* <PosterBanner /> */}

      <Header />
      <div className="hero-container">

        {/* Announcement Bar */}


        {/* NAVIGATION */}
        <div className={`header-wrapper ${small ? "small" : ""}`}>

          <div className="nav-logo">
            <img className={`logo ${small ? "logo-small" : ""}`} src="/logo.jpg" alt="logo" />
          </div>
        </div>


        {/* HERO SECTION */}
        <div className="hero-content">
          <h1>
            <strong> Maryam Jariani</strong></h1>

          <h2>
            MSW , RSW Registered Social Worker , pdychotherspdist and Consultant</h2>
          <Link to="/appointment">
            <button className="book-btn">BOOK NOW</button>
          </Link>        </div>

      </div>






      {/* ===== EDUCATION & APPROACH SECTION ===== */}
      <div className="section-container">

        <div className="left-text-block">
          <h2>🌸 About Me</h2>

          <p>
            Maryam Jariani, BA, BSW, MSW, RSW, PhD C.

            Registered Social Worker, Psychotherapist | Founder & Clinical Director at Mindful Pink World Child & Family Therapy Center

            I am a Registered Social Worker and Psychotherapist providing psychotherapy services to children, youth, individuals, couples, and families across the Greater Toronto Area. I am also the Founder and Clinical Director of Mindful Pink World Child & Family Therapy Center, where I support both clients and clinicians through mindful, compassionate, and developmentally informed care.
          </p>

          <p>
            From an early age, I was naturally attuned to emotions particularly those of children. I did not yet have the language of social work or psychotherapy, but I understood the importance of presence, safety, and being seen. Over time, this early sensitivity shaped my professional path and became the foundation of my work today.

            I bring over seven years of experience across school systems, community agencies, and private practice. My work as a School Social Worker and Attendance Counsellor, alongside my clinical practice, has deepened my understanding of how emotional well-being is influenced by internal experiences, relationships, and broader environments.
          </p>
          <p>At the heart of my work is a core belief:
            To truly support a child, we must also support the parents and caregivers.
            Children spend most of their lives within environments shaped by adults. When caregivers feel supported, regulated, and reflective, children experience greater safety and emotional stability.

            My therapeutic approach is trauma-informed, attachment-based, and mindfulness-informed. I work collaboratively with clients to explore what is happening within the individual, between relationships, and around them in their daily environments. Mindfulness is integrated in practical ways to support emotional awareness, nervous system regulation, and intentional responding rather than reactivity.</p>
          <p>Alongside my clinical work, I hold a Master of Social Work (Honours) from York University and am currently pursuing a PhD in Developmental Psychology. My doctoral research focuses on meditation and emotion regulation, examining how mindful practices support emotional awareness, regulation, and resilience across development. This research informs how I thoughtfully integrate mindfulness into therapy in ways that are accessible, evidence-based, and developmentally appropriate.

            As a mother of two, I understand that parenting is both meaningful and challenging. Parents carry their own histories, stressors, and healing journeys, and they deserve support without judgment. Supporting parents is not separate from supporting children it is essential to it.

            Whether working directly with clients or in my role as Clinical Director, my goal is to create spaces where individuals and families feel safe, supported, and empowered to grow.

            This work is more than a profession to me.
            It is my calling, my purpose, and the path I have always been drawn toward.

          </p>
          <p>🌿 Clinical Leadership & Philosophy
            Mindful Pink World Child & Family Therapy Center

            As the Founder and Clinical Director of Mindful Pink World Child & Family Therapy Center, my role extends beyond individual therapy to shaping a clinical environment rooted in mindfulness, safety, and ethical care. My leadership philosophy is grounded in the belief that healing occurs most effectively within systems that value reflection, compassion, and collaboration.

            At Mindful Pink World, we approach therapy through a mindfulness-informed, children and family-centered lens. This means attending not only to symptoms, but also to emotional experiences, relationships, and environments that influence well-being. We recognize that children do not exist in isolation  their growth is deeply connected to the caregivers, schools, and systems around them.

            My leadership emphasizes:

            Emotional safety and attunement for children and families

            Reflective, trauma-informed, and attachment-based practice

            Cultural responsiveness and anti-oppressive values</p>
        </div>

        {/* ===== CONTACT CARD ===== */}
        <div className="contact-card">
          {/* <h3>Start Your Healing Journey</h3>
          <p className="contact-subtext">
            Healing begins with a single step. We're here to walk alongside you
            towards a healthier, more grounded you.
          </p>

          <div className="info-line">
            <span>📧</span>
            <div>
              <strong>Email</strong>
              <p>info@maryamjsocialwork.ca</p>
            </div>
          </div>

          <div className="info-line">
            <span>📞</span>
            <div>
              <strong>Phone</strong>
              <p>647-726-2999</p>
            </div>
          </div>

          <div className="info-line">
            <span>🕒</span>
            <div>
              <strong>By Appointment</strong>
              <p>Mon–Fri: 10:00 AM – 8:00 PM</p>
              <p>Sat: 10:00 AM – 6:00 PM</p>
            </div>
          </div>

          <a href="/appointment" className="contact-btn">
            → Book a Consultation
          </a> */}
          <img src="/M_pic.jpg"></img>
        </div>



      </div>

      {/* ===== EDUCATION & APPROACH SECTION ===== */}
      <div className="section-container">


        {/* ===== CONTACT CARD ===== */}
        <div className="contact-card">

          <img src="/M_pic2.jpg"></img>
        </div>

        <div className="left-text-block">
          <h2>🌿 My Approach</h2>
          <p>Mindfulness • Attachment • Emotional Regulation

            My therapeutic approach is rooted in the belief that healing happens through presence, connection, and safety. Children, adolescents, and families thrive when they feel understood, supported, and emotionally regulated. My work integrates mindfulness-informed, attachment-based, and emotion regulation approaches to support meaningful and lasting change.

            Rather than focusing only on behaviours or symptoms, I take time to understand the whole child and family system  what is happening internally, relationally, and environmentally. This allows therapy to move beyond short-term solutions and toward deeper healing.</p>

          <p>🌱 Mindfulness: Building Awareness and Presence

            Mindfulness is a foundation of my work. I view mindfulness not as a technique to “stay calm,” but as a way of learning to notice experiences with curiosity and without judgment. In therapy, mindfulness helps children and caregivers slow down, recognize emotions, and respond more intentionally rather than react automatically.

            Mindfulness-informed therapy supports:

            Emotional awareness and expression

            Nervous system regulation

            Stress reduction and self-soothing

            Increased attention, focus, and resilience

            Mindfulness practices are always introduced in developmentally appropriate and practical ways, using play, movement, breath, and everyday language — especially when working with children and adolescents.</p>

          <p>
            💗 Attachment: Strengthening Connection and Safety

            Attachment is at the heart of emotional well-being. Children develop a sense of safety and identity through their relationships with caregivers. When attachment is strained by stress, trauma, or life transitions, children may express distress through behaviour, emotions, or withdrawal.

            An attachment-based approach focuses on:

            Strengthening the child-caregiver relationship

            Supporting attuned, responsive caregiving

            Repairing relational ruptures

            Building trust, safety, and emotional connection

            In therapy, I work collaboratively with parents and caregivers to support understanding, reflection, and connection. Supporting caregivers is not separate from helping children — it is essential to it.
          </p>

          <p>🌿 Emotional Regulation: Supporting the Nervous System

            Emotional regulation is the ability to recognize, manage, and recover from emotional experiences. Many children and adults struggle not because of “bad behaviour,” but because their nervous systems are overwhelmed.

            My approach to regulation focuses on:

            Understanding emotional and bodily signals

            Developing coping and grounding strategies

            Reducing overwhelm and emotional reactivity

            Building resilience over time

            I support clients in learning how emotions work in the body and brain, and how regulation skills can be practiced in everyday life. These skills are essential for managing anxiety, stress, anger, transitions, and relational challenges.
          </p>

          <p>🌸 Working Within, Between, and Around

            My approach considers three interconnected layers:

            Within the individual emotions, thoughts, body awareness, and self-understanding

            Between relationships attachment, communication, and interaction patterns

            Around the environment  family systems, school, culture, and external stressors

            This holistic perspective allows therapy to address both immediate concerns and underlying influences on well-being.</p>

          <p>🌷 A Collaborative and Compassionate Process

            Therapy is a collaborative process. I strive to create a space that feels safe, respectful, and non-judgmental, where clients can explore challenges at their own pace. Whether working with a child, teen, individual, couple, or family, I tailor my approach to meet each client’s unique needs, strengths, and goals.

            I believe that every child deserves to grow in a safe and emotionally attuned environment, and every caregiver deserves support on that journey. Through mindfulness, attachment, and emotional regulation, therapy becomes a space for understanding, connection, and meaningful change</p>

        </div>





      </div>





      {/* ===== CLIENT FOCUS ===== */}
      <div className="client-focus-section">

        <h2 className="client-focus-title">Client Focus</h2>

        <div className="client-focus-grid">

          <div className="client-card">
            <div className="client-icon-wrapper">
              <img src="/icons/age.svg" alt="" className="client-icon" />
            </div>
            <h4>Age</h4>
            <p>Children (6–10), Preteen, Teen, Adults</p>
          </div>

          <div className="client-card">
            <div className="client-icon-wrapper">
              <img src="/icons/group.svg" alt="" className="client-icon" />
            </div>
            <h4>Participants</h4>
            <p>Individuals, Couples, Family</p>
          </div>

          <div className="client-card">
            <div className="client-icon-wrapper">
              <img src="/icons/community.svg" alt="" className="client-icon" />
            </div>
            <h4>Communities</h4>
            <p>
              Deaf Allied, Intersex Allied, Non-Binary Allied, Queer Allied,
              Racial Justice Allied, Single Parent, Transgender Allied
            </p>
          </div>

          <div className="client-card">
            <div className="client-icon-wrapper">
              <img src="/icons/language.svg" alt="" className="client-icon" />
            </div>
            <h4>I also speak</h4>
            <p>Farsi</p>
          </div>

        </div>
      </div>


      {/* ===== PROFESSIONAL FOCUS LIST ===== */}
      <div className="focus-list-section">



        <h2 className="focus-title">Types of Therapy</h2>

        <div className="focus-columns">

          {/* COLUMN 1 */}
          <div className="focus-col">
            <div className="focus-line"></div>

            <AccordionItem title="Acceptance and Commitment (ACT)">
              Acceptance and commitment therapy (ACT) is an action-oriented approach that stems from traditional behavior therapy and cognitive behavioral therapy. Clients learn to stop avoiding, denying, and struggling with their inner emotions and, instead, accept that these deeper feelings are appropriate responses to certain situations that should not prevent them from moving forward in their lives. With this understanding, clients begin to accept their hardships and commit to making necessary changes in their behavior, regardless of what is going on in their lives and how they feel about it.
            </AccordionItem>

            <AccordionItem title="Applied Behavioural Analysis (ABA)">
              Applied Behavior Analysis (ABA) is widely used for children with autism and other developmental disorders. It focuses on teaching specific skills across various domains such as social interaction, communication, academics, motor skills, and self-care. ABA sessions are personalized to each child's needs and are typically intensive, lasting two or more hours multiple times a week, while the duration of therapy varies based on the individual's developmental needs. Research demonstrates that consistent ABA therapy significantly improves behaviors and skills while reducing the need for special services by improving children's independence.
            </AccordionItem>

            <AccordionItem title="Cognitive Behavioural (CBT)">
              Cognitive-behavioural therapy stresses the role of thinking in how we feel and what we do. It is based on the belief that thoughts, rather than people or events, cause our negative feelings. The therapist assists the client in identifying, testing the reality of, and correcting dysfunctional beliefs underlying his or her thinking. The therapist then helps the client modify those thoughts and the behaviours that flow from them. CBT is a structured collaboration between therapist and client and often calls for homework assignments. CBT has been clinically proven to help clients in a relatively short amount of time with a wide range of disorders, including depression and anxiety.
            </AccordionItem>

            <AccordionItem title="Culturally Sensitive">
              Culturally sensitive therapists provide therapy that is culturally sensitive. They understand that people from different backgrounds have different values, practices, and beliefs, and are sensitive to those differences when working with individuals and families in therapy.
            </AccordionItem>

            <AccordionItem title="Emotionally Focused">
              Emotionally Focused Therapy (EFT) is an approach to therapy that helps clients identify their emotions, learn to explore and experience them, to understand them and then to manage them. Emotionally Focused Therapy embraces the idea that emotions can be changed, first by arriving at or 'living' the maladaptive emotion (e.g. loss, fear or shame) in session, and then learning to transform it. Emotionally Focused Therapy for couples seeks to break the negative emotion cycles within relationships, emphasising the importance of the attachment bond between couples, and how nurturing of the attachment bonds and an empathetic understanding of each others emotions can break the cycles.            </AccordionItem>

            <AccordionItem title="Family / Marital">
              Family and Marital therapists work with families or couples both together and individually to help them improve their communication skills, build on the positive aspects of their relationships, and repair the harmful or negative aspects.            </AccordionItem>

            <AccordionItem title="Internal Family Systems (IFS)">
              Internal Family Systems (IFS) is an approach to psychotherapy that identifies and addresses multiple sub-personalities or families within each person’s mental system. These sub-personalities consist of wounded parts and painful emotions such as anger and shame, and parts that try to control and protect the person from the pain of the wounded parts. The sub-personalities are often in conflict with each other and with one’s core Self, a concept that describes the confident, compassionate, whole person that is at the core of every individual. IFS focuses on healing the wounded parts and restoring mental balance and harmony by changing the dynamics that create discord among the sub-personalities and the Self.
            </AccordionItem>
          </div>

          {/* COLUMN 2 */}
          <div className="focus-col">
            <div className="focus-line"></div>

            <AccordionItem title="Mindfulness-Based (MBCT)">
              For clients with chronic pain, hypertension, heart disease, cancer, and other health issues such as anxiety and depression, mindfulness-based cognitive therapy, or MBCT, is a two-part therapy that aims to reduce stress, manage pain, and embrace the freedom to respond to situations by choice. MCBT blends two disciplines--cognitive therapy and mindfulness. Mindfulness helps by reflecting on moments and thoughts without passing judgment. MBCT clients pay close attention to their feelings to reach an objective mindset, thus viewing and combating life's unpleasant occurrences.            </AccordionItem>

            <AccordionItem title="Motivational Interviewing">
              Motivational Interviewing (MI) is a method of therapy that works to engage the motivation of clients to change their behavior. Clients are encouraged to explore and confront their ambivalence. Therapists attempt to influence their clients to consider making changes, rather than non-directively explore themselves. Motivational Interviewing is frequently used in cases of problem drinking or mild addictions.            </AccordionItem>

            <AccordionItem title="Multicultural">
              Multicultural awareness is an understanding and sensitivity of the values, experiences, and lifestyles of minority groups. Differences in race, culture, religion, gender, sexual orientation, socioeconomic status, are all tackled by Multicultural counselling. In the counselling setting, the counsellor recognizes that the client is different from the counsellor and treats the client without forcing the client to be like him or her.            </AccordionItem>

            <AccordionItem title="Narrative">
              Narrative Therapy uses the client's storytelling to indicate the way they construct meaning in their lives, rather than focusing on how they communicate their problem behaviors. Narrative Therapy embraces the idea that stories actually shape our behaviors and our lives and that we become the stories we tell about ourselves. There are helpful narratives we can choose to embrace as well as unhelpful ones. Although it may sound obvious, the power of storytelling is to elevate the client--who is the authority of their narrative--rather than the therapist, as expert.            </AccordionItem>

            <AccordionItem title="Solution Focused Brief (SFBT)">
              Solution-focused therapy, sometimes called "brief therapy," focuses on what clients would like to achieve through therapy rather than on their troubles or mental health issues. The therapist will help the client envision a desirable future, and then map out the small and large changes necessary for the client to undergo to realize their vision. The therapist will seize on any successes the client experiences, to encourage them to build on their strengths rather than dwell on their problems or limitations.            </AccordionItem>

            <AccordionItem title="Strength-Based">
              Strength-based therapy is a type of positive psychotherapy and counselling that focuses more on your internal strengths and resourcefulness, and less on weaknesses, failures, and shortcomings. This focus sets up a positive mindset that helps you build on you best qualities, find your strengths, improve resilience and change worldview to one that is more positive. A positive attitude, in turn, can help your expectations of yourself and others become more reasonable.            </AccordionItem>

            <AccordionItem title="Trauma Focused">
              Trauma focused cognitive behavioral therapy (TF-CBT) helps people who may be experiencing post-traumatic stress after a traumatic event to return to a healthy state.            </AccordionItem>
          </div>
          {/* COLUMN 3 */}
          <div className="focus-col">
            <div className="focus-line"></div>

            <AccordionItem title="PTSD">
              Post-Traumatic Stress Disorder (PTSD) is a mental health condition that can develop after experiencing or witnessing a traumatic event, often involving symptoms such as anxiety, intrusive memories, and emotional distress.            </AccordionItem>

            <AccordionItem title="Anxiety & Stress">
              Anxiety & Stress are common emotional responses to life challenges that can affect daily functioning, relationships, and overall well-being, but are manageable with the right support and coping strategies.   </AccordionItem>

            <AccordionItem title="Grief">
              Grief is a natural response to loss that can affect emotional, mental, and physical well-being, and everyone experiences it in their own way.        </AccordionItem>

            <AccordionItem title="Complex Truma">
              Complex Trauma refers to the long-term effects of repeated or prolonged traumatic experiences, often impacting emotional regulation, self-identity, and relationships.            </AccordionItem>

            <AccordionItem title="Single Incident Truma">
              Single-Incident Trauma refers to psychological distress resulting from a one-time traumatic event such as an accident, assault, or natural disaster.  </AccordionItem>

            <AccordionItem title="Development Truma">
              Developmental Trauma refers to the impact of early life experiences, such as chronic stress or neglect, on emotional development, attachment, and self-regulation.           </AccordionItem>

            <AccordionItem title="EMDR">
              EMDR (Eye Movement Desensitization and Reprocessing) is a trauma-focused therapy that helps individuals process distressing memories and reduce their emotional impact.            </AccordionItem>
          </div>
          {/* COLUMN 4 */}
          <div className="focus-col">
            <div className="focus-line"></div>

            <AccordionItem title="Somatic Psychotherapy">
              Somatic Psychotherapy is a body-centered approach that helps individuals process trauma and emotions by increasing awareness of physical sensations and bodily responses.            </AccordionItem>

            <AccordionItem title="Accelerated Resoloution Therepy">
              Accelerated Resolution Therapy (ART) is an evidence-based, trauma-focused therapy that helps individuals quickly process distressing memories and reduce their emotional impact using guided imagery and eye movements.            </AccordionItem>

            <AccordionItem title="Brain-Body Integration">
              Brain–Body Integration is an approach that strengthens the connection between the brain and body to support emotional regulation, trauma healing, and overall well-being.           </AccordionItem>

          </div>




        </div>


      </div>

      {/* ===== LOCATION + TESTIMONIAL SECTION ===== */}
      <EducationCarousel />



    </>
  );
}

export default Home;
